import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const DemandPlanningRBAC = {
  pageID: 'c537f36241ce2d004125cdbf5e87bd9a',
  elementID: {
    ViewDemandPlanning: '5c3a5e25ad9ef6ca55e428c6267941d7',
  },
} as const
export const useRBACDemandPlanningPage = createUseRBAC(DemandPlanningRBAC.elementID)
export type UseRBACDemandPlanningPageType = ReturnType<typeof useRBACDemandPlanningPage>

export const SKUDetailsReviewRBAC = {
  pageID: 'a4ae655257eef1bbc2539845b69976b0',
  elementID: {
    ViewSKUDetailsReview: 'c2df28561eec700ea93950eeef32b400',
    CompleteReview: 'a761710df6c6b763f8dc917e1706de1d',
  },
} as const
export const useRBACSKUDetailsReviewPage = createUseRBAC(SKUDetailsReviewRBAC.elementID)
export type UseRBACSKUDetailsReviewPageType = ReturnType<typeof useRBACSKUDetailsReviewPage>

export const ConfigBankRBAC = {
  pageID: 'ef638c824a6c947871a0d46861ad135c',
  elementID: {
    ViewConfigBank: 'b28405301876ec0466934a8511b3a647',
  },
} as const
export const useRBACConfigBankPage = createUseRBAC(ConfigBankRBAC.elementID)
export type UseRBACConfigBankPageType = ReturnType<typeof useRBACConfigBankPage>

export const CampaignDashboardRBAC = {
  pageID: '3a474acf0d6267993ee462a1bc20e382',
  elementID: {
    ViewCampaignDashboard: '26b9ef3d5d0f2c6142c53be650329335',
    MakeCampaignCorrections: 'd3f43a9b39b548ead6a97e2d7a6052a1',
  },
} as const
export const useRBACCampaignDashboardPage = createUseRBAC(CampaignDashboardRBAC.elementID)
export type UseRBACCampaignDashboardPageType = ReturnType<typeof useRBACCampaignDashboardPage>

export const CampaignHistoryRBAC = {
  pageID: 'abdcdc318c52bae789268943a4fdb572',
  elementID: {
    ViewCampaignHistory: 'a3fe275ebf438584b7d88ccae6c503c1',
  },
} as const
export const useRBACCampaignHistoryPage = createUseRBAC(CampaignHistoryRBAC.elementID)
export type UseRBACCampaignHistoryPageType = ReturnType<typeof useRBACCampaignHistoryPage>

export const FestiveDashboardRBAC = {
  pageID: '3a474acf0d6267993ee462a1bc20e382',
  elementID: {
    ViewFestiveDashboard: '26b9ef3d5d0f2c6142c53be650329335',
  },
} as const
export const useRBACFestiveDashboardPage = createUseRBAC(FestiveDashboardRBAC.elementID)
export type UseRBACFestiveDashboardPageType = ReturnType<typeof useRBACFestiveDashboardPage>

export const FestiveHistoryRBAC = {
  pageID: 'abdcdc318c52bae789268943a4fdb572',
  elementID: {
    ViewFestiveHistory: 'a3fe275ebf438584b7d88ccae6c503c1',
  },
} as const
export const useRBACFestiveHistoryPage = createUseRBAC(FestiveHistoryRBAC.elementID)
export type UseRBACFestiveHistoryPageType = ReturnType<typeof useRBACFestiveHistoryPage>
